import type { Traducao } from '../tipos';

/**
 * Rótulo dos valores de domínio que vêm do BANCO e formam conjunto fechado:
 * status e área do ativo. O dado continua em português (é o que a API grava,
 * filtra e compara); só a etiqueta na tela acompanha o idioma.
 *
 * A chave é um SLUG do valor, não o valor: `t()` separa segmentos por ponto, e
 * há área com ponto no nome ("28-ACAB., ESTOCAGEM..."), que quebraria o caminho.
 * Ver `chaveDominio` em ../dominio.ts — a mesma função gera estas chaves.
 *
 * Valor fora destas listas (status novo, área nova) cai no próprio valor, nunca
 * na chave crua.
 */
export const dominio: Traducao = {
  pt: {
    statusAtivo: {
      LEVANTADO: 'LEVANTADO',
      ATENDER_PAINEL: 'ATENDER PAINEL',
      LEVANTAR: 'LEVANTAR',
      TRAMITADO: 'TRAMITADO',
      VERIFICAR_SE_IRA_SEPARAR_OS_EQUIPAMENTOS: 'VERIFICAR SE IRÁ SEPARAR OS EQUIPAMENTOS',
      DESATIVADO: 'DESATIVADO',
      CANCELADO_SEM_SISMANA: 'CANCELADO, SEM SISMANA',
      VERIFICAR_TRAMITACAO: 'VERIFICAR TRAMITAÇÃO',
      TRAMITAR: 'TRAMITAR',
      CODIGO_SISMANA_IGUAL_MAIS_DE_UMA_MAQUINA_NO_CODIGO: 'CODIGO SISMANA IGUAL, MAIS DE UMA MÁQUINA NO CÓDIGO',
      EQUIPAMENTO_JA_LEVANTADO: 'EQUIPAMENTO JÁ LEVANTADO',
      EQUIPAMENTO_INACESSIVEL: 'EQUIPAMENTO INACESSÍVEL',
      PADRONIZAR: 'PADRONIZAR',
      PENDENTE: 'pendente',
      NAO_LOCALIZADO: 'NÃO LOCALIZADO',
      // Rótulos que o BACKEND calcula quando o campo está vazio
      // (ativo.service / relatorio-mensal.helpers) — chegam prontos no payload.
      SEM_STATUS: 'Sem status',
    },
    areaAtivo: {
      '01_COQUERIA': '01-COQUERIA',
      '02_SINTERIZACAO': '02-SINTERIZAÇÃO',
      '03_PATIO_DE_MINERIOS': '03-PÁTIO DE MINÉRIOS',
      '04_ALTO_FORNO': '04-ALTO FORNO',
      '07_ACIARIA': '07-ACIARIA',
      '19_OFICINAS_DE_MANUTENCAO': '19-OFICINAS DE MANUTENCAO',
      '20_FUNDICAO': '20-FUNDIÇÃO',
      '23_APOIO_A_PRODUCAO': '23-APOIO A PRODUCAO',
      '25_PREDIOS_E_PATIOS_ADMINISTRATIVOS': '25-PREDIOS E PATIOS ADMINISTRATIVOS',
      '26_LAMINADOR_DE_TIRAS_A_QUENTE': '26-LAMINADOR DE TIRAS A QUENTE',
      '28_ACAB_ESTOCAGEM_E_DESPACHO_BOBINAS': '28-ACAB., ESTOCAGEM E DESPACHO BOBINAS',
      SEM_AREA: 'Sem área',
    },
  },
  en: {
    statusAtivo: {
      LEVANTADO: 'SURVEYED',
      ATENDER_PAINEL: 'PANEL REQUEST',
      LEVANTAR: 'TO SURVEY',
      TRAMITADO: 'SUBMITTED',
      VERIFICAR_SE_IRA_SEPARAR_OS_EQUIPAMENTOS: 'CHECK IF EQUIPMENT WILL BE SPLIT',
      DESATIVADO: 'DEACTIVATED',
      CANCELADO_SEM_SISMANA: 'CANCELLED, NO SISMANA',
      VERIFICAR_TRAMITACAO: 'CHECK SUBMISSION',
      TRAMITAR: 'TO SUBMIT',
      CODIGO_SISMANA_IGUAL_MAIS_DE_UMA_MAQUINA_NO_CODIGO: 'SAME SISMANA CODE, MORE THAN ONE MACHINE',
      EQUIPAMENTO_JA_LEVANTADO: 'EQUIPMENT ALREADY SURVEYED',
      EQUIPAMENTO_INACESSIVEL: 'EQUIPMENT INACCESSIBLE',
      PADRONIZAR: 'TO STANDARDIZE',
      PENDENTE: 'pending',
      NAO_LOCALIZADO: 'NOT FOUND',
      SEM_STATUS: 'No status',
    },
    areaAtivo: {
      '01_COQUERIA': '01-COKE PLANT',
      '02_SINTERIZACAO': '02-SINTER PLANT',
      '03_PATIO_DE_MINERIOS': '03-ORE YARD',
      '04_ALTO_FORNO': '04-BLAST FURNACE',
      '07_ACIARIA': '07-STEEL SHOP',
      '19_OFICINAS_DE_MANUTENCAO': '19-MAINTENANCE WORKSHOPS',
      '20_FUNDICAO': '20-FOUNDRY',
      '23_APOIO_A_PRODUCAO': '23-PRODUCTION SUPPORT',
      '25_PREDIOS_E_PATIOS_ADMINISTRATIVOS': '25-ADMINISTRATIVE BUILDINGS AND YARDS',
      '26_LAMINADOR_DE_TIRAS_A_QUENTE': '26-HOT STRIP MILL',
      '28_ACAB_ESTOCAGEM_E_DESPACHO_BOBINAS': '28-COIL FINISHING, STORAGE AND SHIPPING',
      SEM_AREA: 'No area',
    },
  },
};
